import { Component } from "react";

/** Top-level React error boundary that renders the friendly Error page
 * instead of a blank screen if a rendering error occurs. */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    // Intentionally minimal: avoid logging any user-entered data.
    // eslint-disable-next-line no-console
    console.error("Unhandled UI error:", error.message);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback;
    }
    return this.props.children;
  }
}
